<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="title-frontMatter"><a href="#/e9781466821378_toc01#toctitle2" id="title2"><span><em class="i"><strong class="b">Prologue: Baalit Sings</strong></em></span></a></div>
<div class="p"><span><em class="i">SOLOMON WAS A GREAT KING, A MAN OF WISDOM AND POWER; Bilqis was a djinn’s daughter, a creature of sand and fire.</em> So a harper would begin this tale; it is tradition, after all. And so shall I begin my own song to tell the tale of my father and the woman who became more to me than my own mother—for when one has broken every rule and violated every commandment, only tradition can redeem that tale, make it sweet to swallow.</span></div>
<div class="p-indent"><span>Sing it so, if you choose: a golden king and a queen from the land beyond morning, well met in a contest of wits and wills. She tried him with hard questions; he answered each with ease. Whereupon the lady bowed before his wisdom, praised his greatness, and then retreated to her faraway kingdom, laden down with priceless gifts freely given by the all-knowing king.</span></div>
<div class="p-indent"><span><em class="i">Whatsoever she desired,</em> sing the harpers now. <em class="i">King Solomon granted all the great queen’s heart desired</em>—</span></div>
<div class="p-indent"><span>But not freely. No, what Solomon the Wise granted unto the foreign queen from the south, her heart’s desire, was given unwilling, forfeit to a king’s honor. The harpers do not sing of that; hard Truth is no man’s daughter.</span></div>
<div class="p-indent"><span>So I shall sing their song in my own words, and in theirs, trusting their tale to the winds of time. I, who in my turn shall be Queen of the Spice Lands, Queen of the South—I will sing for you the tale of Solomon the Wise, and Bilqis, Queen of the Morning.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466821378_fm02.vue?6eee872e